import React, { useEffect, useState } from 'react';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { success, failure } from '~/redux/actions/snackbar-actions';
import { getTeamMembersData, updateRole } from '~/redux/actions/user-actions';

import { MESSAGES } from '~/utils/message';

// Components
import OlcDropdownSearch from '~/components/General/OlcDropdownSearch';
import { USER_ROLE_OPTIONS } from '../roleOptions';

// Mui components
import Typography from '@mui/material/Typography';
import { Box, CircularProgress } from '@mui/material';

import OlcButton from '~/components/General/OlcButton';
import OlcFormModal from '~/components/General/OlcFormModal';

const EditUserModal = (props) => {
  const { selectedUser, openModal, handleCloseModal, pagination } = props;
  const [selectedRole, setSelectedRole] = useState(null);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onClose = () => {
    setSelectedRole(null);
    setLoading(false);
    handleCloseModal();
  };

  const onUpdateRole = async () => {
    try {
      setLoading(true);
      const payload = {
        id: selectedUser?.id,
        role: selectedRole.value,
      };
      const response = await dispatch(updateRole(payload));
      if (response.status === 200) {
        dispatch(success(response.data.message));
        dispatch(getTeamMembersData(pagination));
        onClose();
      } else {
        dispatch(failure(response.data.message));
      }
    } catch (error) {
      return error;
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    if (selectedUser) {
      const currentRole = USER_ROLE_OPTIONS.find((role) => role.value === selectedUser?.role?.slug);
      if (currentRole) {
        setSelectedRole(currentRole);
      }
    }
  }, [openModal]);

  useEffect(() => {
    if (!openModal) {
      // Reset all state when modal closes
      setSelectedRole(null);
      setLoading(false);
    }
  }, [openModal]);

  return (
    <OlcFormModal
      open={openModal}
      onClose={onClose}
      title={MESSAGES.ACCOUNT.USERS.EDIT_USER_ROLE.TITLE}
      className="editUserFormModal"
      footer={
        <>
          <OlcButton variant="secondary" onClick={onClose} disabled={loading}>
            {MESSAGES.ACCOUNT.USERS.EDIT_USER_ROLE.CANCEL_BUTTON}
          </OlcButton>
          <OlcButton variant="primary" onClick={onUpdateRole} disabled={loading}>
            {loading ? (
              <CircularProgress
                sx={{
                  color: 'white',
                  width: '20px !important',
                  height: '20px !important',
                }}
              />
            ) : (
              MESSAGES.ACCOUNT.USERS.EDIT_USER_ROLE.SUBMIT_BUTTON
            )}
          </OlcButton>
        </>
      }
    >
      <Box className="modalFormWrapper">
        <Box className="modalFlexArea">
          <Box className="olcSelectBox">
            <Typography className="inputLabel formLabel">
              {MESSAGES.ACCOUNT.USERS.EDIT_USER_ROLE.ROLE_LABEL}
            </Typography>
            <OlcDropdownSearch
              placeHolderText="Select Role"
              searchFieldPlaceholderText="roles"
              noOptionText="No roles found"
              options={USER_ROLE_OPTIONS}
              selectedValue={selectedRole}
              setSelectedValue={setSelectedRole}
            />
          </Box>
        </Box>
      </Box>
    </OlcFormModal>
  );
};

export default EditUserModal;
